import { IAppContext } from 'wisestep-api';

export function defaultSettings(): IAppContext {
  const settings: IAppContext = {
    generalSettings: {
      logo: '',
      logoURL: '',
      companyName: '',
      companyNameSlug: null,
      about: null,
      pageHeading: 'Work with us!',
      companySectionHeading: 'About Us',
      jobSectionHeading: 'Our Openings',
    },

    appearanceSettings: {
      showLogoText: true,
      logoLocation: 'center',
      bannerType: 'image',
      bannerBackgroundColor: '',
      companySectionHeadingLocation: 'center',
      jobSectionHeadingLocation: 'center',
      pageHeadingColor: '#000000',
      headerBackgroundColor: '#2b3d51',
      headerTextColor: '#ffffff',
      footerBackgroundColor: '#1e2022',
      footerTextColor: '#ffffff',
      banner: '',
      footerFontSize: '16px',
      bannerFontSize: '48px',
      headingFontSize: '32px',
      headingFontColor: '#3b4351',
      contentFontColor: '#77838f',
      contentFontSize: '16px',
      mainBackgroundColor: '#f8f8f8',
      headerFontSize: '40px',
      siteFont: 'Poppins',
      isHeader: true,
      isBanner: false,
      isFooter: true,
      primaryColor: '#2b3d51',
      primaryTextColor: '#000000',
      secondaryColor: '#4a98cc',
      secondaryTextColor: '#6E6E6E',
    },

    candidatesSettings: {
      candidateName: 'mandatory',
      candidateEmail: 'mandatory',
      candidatePhone: 'mandatory',
      candidateAlternateEmail: 'notmandatory',
      linkedInUrl: 'notmandatory',
      messengerId: 'hide',
      certifications: 'hide',
      jobPreference: 'hide',
      commPreference: 'hide',
      location: 'notmandatory',
      skills: 'hide',
      highestQualification: 'notmandatory',
      institutionAttended: 'hide',
      currentJobTitle: 'notmandatory',
      previousJobTitle: 'hide',
      currentEmployer: 'notmandatory',
      previousEmployer: 'hide',
      totalExperience: 'hide',
      relevantExperience: 'notmandatory',
      currentSalary: 'notmandatory',
      expectedSalary: 'notmandatory',
      otherBenefit: 'notmandatory',
      expectedBenefits: 'notmandatory',
      relocationPreference: 'notmandatory',
      noticePeriod: 'notmandatory',
      currentJobType: 'notmandatory',
      otherInterviewStage: 'hide',
      reasonForJob: 'hide',
      recruiterAssessment: 'notmandatory',
      workAuthorization: 'notmandatory',
      currentJobTravel: 'notmandatory',
      willingToTravel: 'notmandatory',
      familyWillingToRelocate: 'hide',
      interviewingWithOthers: 'hide',
      resumeUpload: 'mandatory',
      otherDocuments: 'hide',
    },

    jobsSettings: {
      jobTitle: true,
      companyName: true,
      location: true,
      compensation: true,
      description: true,
      skills: true,
      tags: true,
      postedDate: true,
      jobType: true,
    },

    emailSettings: {
      sendJobCloseNotificationEmail: true,
      sendCandidateAcknowledgment: true,
      sendJobPosterAcknowledgment: true,
      jobPosterAcknowledgmentBcc: '',
      jobPosterAcknowledgmentCc: '',
      candidateAcknowledgementContent:
        '<div><!--block-->Hello [CANDIDATE_NAME],<br><br></div><div><!--block-->We have received your application for the position of [JOB_TITLE]. Our hiring team is currently reviewing all applications. If you are among qualified candidates, you will receive an e-mail from one of our recruiters to schedule an interview.<br><br></div><div><!--block-->Regards,<br><br></div><div><!--block-->Wisestep team.<br><br></div>',
      candidateAcknowledgmentSender: '',
      candidateAcknowledgmentBcc: '',
      candidateAcknowledgmentCc: '',
      candidateAcknowledgmentSubject: 'Thank you for your application.',
      jobCloseNotificationEmailContent:
        "<div><!--block-->Hello [CANDIDATE_NAME],<br><br>Thank you for your interest in joining our team. We wanted to let you know that we're closing the job you applied for.</div><div><!--block-->We will, however, keep your resume on record and get in touch with you about future opportunities that may fit for your skills and experience.<br><br></div><div><!--block-->We wish you all the best in your job search.<br><br></div><div><!--block-->Regards,</div><div><!--block-->Wisestep team.<br><br></div>",
      jobCloseNotificationEmailSender: '',
      jobCloseNotificationEmailBcc: '',
      jobCloseNotificationEmailCc: '',
      jobCloseNotificationEmailSubject: 'Job Closed',
    },

    integrationSettings: {
      facebookShare: true,
      linkedInShare: true,
      emailShare: true,
    },

    isPreview: false,
    slug: '',
    userId: '',
    // liveEdit: null,
    domain: '',
  };
  return settings;
}
